export function setupG2(userId) {
  console.log('setupG2', userId);
  setTimeout(() => {
    (function (c, p, d, u, id, i) {
      id = ''; // Optional Custom ID for user in your system
      if (userId) {
        id = userId;
      }
      u =
        'https://tracking-api.g2.com/attribution_tracking/conversions/' +
        c +
        '.js?p=' +
        encodeURI(p) +
        '&e=' +
        id;
      i = document.createElement('script');
      i.type = 'application/javascript';
      i.async = true;
      i.src = u;
      d.getElementsByTagName('head')[0].appendChild(i);
    })('1027464', document.location.href, document);
  });
}
